// src/app/services/louverApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { ILouver, ILouverParams, UpdatePayload } from '../models';

export const louverApi = createApi({
  reducerPath: 'louverApi',
  baseQuery,
  endpoints: (builder) => ({
    getLouverParams: builder.query<{ louver: ILouverParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/louvers/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
      transformResponse: (data: { louver: ILouverParams }) => {
        data.louver.mounting_plane = data.louver.mounting_plane.filter(
          (el) => el.id < 7
        );
        return data;
      },
    }),
    getLouver: builder.query<ILouver, number>({
      query: (id) => `/api/v1.0/ahu/louvers/${id}`,
      transformResponse: (data: ILouver) => {
        data.params = data.louver_params ? JSON.parse(data.louver_params) : {};
        return data;
      },
    }),
    getAllLouversCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/louvers/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getLouversCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/louvers/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    updateLouver: builder.mutation<ILouver, UpdatePayload<ILouver>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/louvers/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
      transformResponse: (data: ILouver) => {
        data.params = data.louver_params ? JSON.parse(data.louver_params) : {};
        return data;
      },
    }),
  }),
});

export const {
  useLazyGetLouverQuery,
  useGetLouverParamsQuery,
  useGetAllLouversCountQuery,
  useLazyGetLouversCountQuery,
  useGetLouverQuery,
  useUpdateLouverMutation,
} = louverApi;
